// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"360":"4f7a88a7f7eb1a3641f9","558":"c78d011ba1d19ef64a7f"}[chunkId] + ".js";
};